import React from 'react'

const TopCards = (props) => {
    let  {totalApp,liveApp,completedApp} = props.data;
    return (
     <div>
         <div className="col s12 m4">
    <div className="card orange darken-1 hoverable">
    <div className="card-content white-text">
    <span className="card-title"> <i className="material-icons">insert_chart</i>Total Apps</span>
    <h5 className="center">{totalApp}</h5>
    </div>
    </div>
    </div>

    <div className="col s12 m4">
    <div className="card indigo darken-1 hoverable">
    <div className="card-content white-text">
    <span className="card-title"> <i className="material-icons">public</i> Published Apps</span>
    <h5 className="center">{liveApp}</h5>
    </div>
    </div>
    </div>

    <div className="col s12 m4">
    <div className="card cyan hoverable">
    <div className="card-content white-text">
    <span className="card-title"> <i className="material-icons">done</i>Completed Apps</span>
    <h5 className="center">{completedApp}</h5>
    </div>
    </div>
    </div>
     </div>
    )
}

export default TopCards
